//options

function widgetStart(_aqi101, isStatic,containerId,options){
    //widgetSetUp(isStatic);
    var containId = containerId ? containerId : "widget-container";
    var _aqi = Math.ceil(_aqi101/10);
    var interval;
    if(isStatic) interval = 60;
    else interval = 200;

    try {
        //completely desaturate
        resetWidget(containId);
        //widget will make requests to the api and display actual aqi values;
        //this is receiving props from the for the website
        var aqi = _aqi;
        var step = 0;
        //animate
        var ascend = setInterval(function(){
            if(step <= aqi){
                var text = document.getElementById("widget-text"+containId);
                try {
                    text.innerHTML = '';
                }
                catch(e){};
                //step++;
                widgetFeed(step++,containId,isStatic);
            }
            else{
                if(options && options.displayScore)
                    widgetTextFeed(_aqi101,containId,options);
                else
                    widgetTextFeed(_aqi,containId,options);
                clearInterval(ascend);
            }
        }, interval);
    }
    catch(e){
        console.log(e)
    }
}

export function widgetSetUp(isStatic,containerId,options){
    var containId = containerId ? containerId : "widget-container";
    //restrict width for proper scaling
    var widget_width = 200;
    //div containing the widget
    var widget = document.createElement('div');
    widget.className = 'widget';
    widget.setAttribute('id', 'widget'+containId);

    if(isStatic || options.solidBackground){
        widget.setAttribute('style', 'border-radius: 50%; width: 100%; height: 100%; text-align: center');
    }
    else{
        widget.setAttribute('style', 'background: radial-gradient( circle, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 35%, rgba(0,0,0,0) 65%, rgba(0,0,0,0.0) 100%); border-radius: 50%; width: 100%; height: 100%;');
    }
    //create svg element to render the paths
    var ns = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns,'svg');
    svg.setAttributeNS(null, 'class', 'drop');
    svg.setAttributeNS(null, 'id', 'widget-graphics'+containId);
    svg.setAttributeNS(null, 'viewBox', '0 0 '+widget_width+' '+widget_width);
    svg.setAttributeNS(null, 'style', 'position: relative;');
    //create the paths
    var drop_0 = generateDrop(0, widget_width,containId);
    var drop_1 = generateDrop(1, widget_width,containId);
    var drop_2 = generateDrop(2, widget_width,containId);
    var drop_3 = generateDrop(3, widget_width,containId);
    var drop_4 = generateDrop(4, widget_width,containId);
    var drop_5 = generateDrop(5, widget_width,containId);
    var drop_6 = generateDrop(6, widget_width,containId);
    var drop_7 = generateDrop(7, widget_width,containId);
    var drop_8 = generateDrop(8, widget_width,containId);
    var drop_9 = generateDrop(9, widget_width,containId);
    var drop_10 = generateDrop(10, widget_width,containId);
    //populate the svg
    svg.appendChild(drop_0);
    svg.appendChild(drop_1);
    svg.appendChild(drop_2);
    svg.appendChild(drop_3);
    svg.appendChild(drop_4);
    svg.appendChild(drop_5);
    svg.appendChild(drop_6);
    svg.appendChild(drop_7);
    svg.appendChild(drop_8);
    svg.appendChild(drop_9);
    svg.appendChild(drop_10);

    widget.appendChild(svg);
    //container for agi score
    //text is for website only actual widget will show the figure
    var text = document.createElement('h2');
    text.setAttribute('style', 'height: 100%; width: 100%; position: absolute; top: 0; margin: 0; color: white; display: flex; align-items: center; justify-content:center; font-weight: 500');
    text.setAttribute('class', 'widget-text');
    text.setAttribute('id', 'widget-text'+containId);
    //put widget and text overlay in the container
    var container = document.getElementById(containId);
    container.appendChild(widget);
    container.appendChild(text);
}

function generateDrop(index,widget_width,containerId){

    var scale_coeff = widget_width/450;
    var ns = "http://www.w3.org/2000/svg";
    //dropplet path
    var drop = document.createElementNS(ns, 'g');
    var drop_shape = document.createElementNS(ns, 'path');
    var shape = "M16.41,56A39.62,39.62,0,1,0,84,28L70,14,56,0,42,14,28,28a39.5,39.5,0,0,0-11.6,28";
    drop_shape.setAttributeNS(null, 'd', shape);
    drop_shape.setAttributeNS(null, 'transform', 'rotate(45 60.59617614746094 51.10868072509766) matrix('
        +Math.cos(45)+' '+Math.sin(45)+' '+(-Math.sin(45))+' '+Math.cos(45)+' '+(widget_width*Math.sin(scale_coeff)*0.6)
        +' '+(-widget_width*Math.cos(scale_coeff)*0.6)+')');
    drop.setAttributeNS(null, 'id', 'drop-'+index+containerId);
    drop.setAttributeNS(null, 'fill', 'rgba(255,255,255,0.3)');
    drop.appendChild(drop_shape);
    //position and rotation
    drop.setAttributeNS(null, 'style', 'transition: fill 0.5s;');
    drop.setAttributeNS(null, 'transform', 'scale('
        +scale_coeff+', '+scale_coeff+') translate(120 120) rotate('+((index*30)-1)+' 100 100)');

    return drop;
}

function widgetFeed(aqi,containerId, isStatic){
    //discolor every dropplet
    if(!isStatic){
        try{
            widgetDesaturate(containerId);
        }
        catch(e){};
    }
    //color it
    try{
        widgetSaturate(aqi,containerId);
    }
    catch(e){};
}

function widgetTextFeed(aqi,containerId,options){
    var text = document.getElementById("widget-text"+containerId);
    var displayText =  "";
    if(options && options.displayScore){
        try{
            if(aqi){
                displayText = "<div style='display:block'><h1>"+aqi+"</h1><p>AQI</p></div>";
            }

        }catch(e){}
    }else{
        if(aqi < 2){
            displayText = options.locale === 'en' ? 'Very Bad' : 'Zeer Slecht';
        }
        else if(aqi < 5){
            displayText = options.locale === 'en' ? 'Bad' : 'Slecht';
        }
        else if(aqi < 8){
            displayText = options.locale === 'en' ? 'Moderate' : 'Matig';
        }
        else if(aqi <= 10){
            displayText = options.locale === 'en' ? 'Good' : 'Goed';
        }
    }

    try{
        text.innerHTML = displayText;
    }catch(e){

    }
}

function widgetDesaturate(containerId){
    for(var i = 0; i < 11; i++){
        var drop = document.getElementById('drop-'+i+containerId);
        //color
        var drop_color = drop.getAttributeNS(null, 'fill');
        //calculate the new color
        var colors = drop_color.substring(drop_color.indexOf('(')+1, drop_color.indexOf(')')).split(',');

        if(parseInt(colors[0], 10) !== 255 || parseInt(colors[1], 10) !== 255 || parseInt(colors[2], 10) !== 255){
            colors[3] = 0.2;
        }
        var newColor = 'rgba('+colors[0]+','+colors[1]+','+colors[2]+','+colors[3]+')';
        drop.setAttribute('fill', newColor);
    }
}

function widgetSaturate(aqi,containerId){

    if(aqi < 1){
        var drop_0 = document.getElementById("drop-0"+containerId);
        drop_0.setAttributeNS(null, 'fill', 'rgba(180,0,0, 1)');
    }
    else if(aqi < 2){
        var drop_1 = document.getElementById("drop-1"+containerId);
        drop_1.setAttributeNS(null, 'fill', 'rgba(210,50,50, 1)');
    }
    else if(aqi < 3){
        var drop_2 = document.getElementById("drop-2"+containerId);
        drop_2.setAttributeNS(null, 'fill', 'rgba(237,104,73, 1)');
    }
    else if(aqi < 4){
        var drop_3 = document.getElementById("drop-3"+containerId);
        drop_3.setAttributeNS(null, 'fill', 'rgba(240,143,76, 1)');
    }
    else if(aqi < 5){
        var drop_4 = document.getElementById("drop-4"+containerId);
        drop_4.setAttributeNS(null, 'fill', 'rgba(244,170,89, 1)');
    }
    else if(aqi < 6){
        var drop_5 = document.getElementById("drop-5"+containerId);
        drop_5.setAttributeNS(null, 'fill', 'rgba(252,209,122, 1)');
    }
    else if(aqi < 7){
        var drop_6 = document.getElementById("drop-6"+containerId);
        drop_6.setAttributeNS(null, 'fill', 'rgba(255,237,150, 1)');
    }
    else if(aqi < 8){
        var drop_7 = document.getElementById("drop-7"+containerId);
        drop_7.setAttributeNS(null, 'fill', 'rgba(255,255,180, 1)');
    }
    else if(aqi < 9){
        var drop_8 = document.getElementById("drop-8"+containerId);
        drop_8.setAttributeNS(null, 'fill', 'rgba(163,214,229, 1)');
    }
    else if(aqi < 10){
        var drop9 = document.getElementById("drop-9"+containerId);
        drop9.setAttributeNS(null, 'fill', 'rgba(91,181,206, 1)');
    }
    else if (aqi === 10){
        var drop_10 = document.getElementById("drop-10"+containerId);
        drop_10.setAttributeNS(null, 'fill', 'rgba(0,130,175, 1)');
    }
}


export function resetWidget(containerId){
    var containId = containerId ? containerId : "widget-container";
    var text = document.getElementById("widget-text"+containId);

    try{
        text.innerHTML = '';
    }catch(e){};
    for(var i = 0; i < 11; i++){
        var drop = document.getElementById('drop-'+i+containId);
        drop.setAttribute('fill', 'rgba(255,255,255,0.3)');
    }
}
//export default widgetStart;

module.exports = {
    widgetStart: widgetStart,
    widgetSetUp: widgetSetUp,
    resetWidget:resetWidget
};



// WEBPACK FOOTER //
// ./src/components/widget/widget.js